import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import {
	hasViewCafeteriaInventoryPermission,
	hasViewCafeteriaRequisitionsPermission,
	hasViewCafeteriaVendorsPermission,
	hasViewOrdersPermission,
	hasViewShowcasePermission,
	hasViewTakeOrderPermission,
	hasViewTransactionHistoryPermission,
	hasViewTransactionsPermission,
} from '../../permission-utils/cafeteria';
import { checkHOD, checkHOU } from '../../permission-utils/settings';

const CafeteriaMenu = () => {
	const [isSupervisor, setIsSuperVisor] = useState(false);
	const user = useSelector(state => state.user.profile);

	useEffect(() => {
		const fetchData = async () => {
			const isHOD = await checkHOD();
			const isHOU = await checkHOU();

			if (isHOD || isHOU) {
				setIsSuperVisor(true);
			}
		};

		fetchData();
	}, []);

	return (
		<>
			{(isSupervisor || hasViewCafeteriaInventoryPermission(user.permissions)) && (
				<li>
					<Link to="/cafeteria/overview">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Overview</span>
					</Link>
				</li>
			)}
			{(hasViewOrdersPermission(user.permissions) ||
				hasViewShowcasePermission(user.permissions) ||
				hasViewTakeOrderPermission(user.permissions) ||
				hasViewTransactionsPermission(user.permissions)) && (
				<li>
					<Link to={hasViewTakeOrderPermission(user.permissions) ? '/cafeteria' : '/cafeteria/orders'}>
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Dashboard</span>
					</Link>
				</li>
			)}
			{hasViewCafeteriaInventoryPermission(user.permissions) && (
				<li>
					<Link to="/cafeteria/inventory">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Inventory</span>
					</Link>
				</li>
			)}
			{hasViewCafeteriaVendorsPermission(user.permissions) && (
				<li>
					<Link to="/cafeteria/vendors">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Vendors</span>
					</Link>
				</li>
			)}
			{hasViewCafeteriaVendorsPermission(user.permissions) && (
				<li>
					<Link to="/cafeteria/cafeteria">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Categories</span>
					</Link>
				</li>
			)}
			{hasViewCafeteriaRequisitionsPermission(user.permissions) && (
				<li>
					<Link to="/cafeteria/requisitions">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Requisitions</span>
					</Link>
				</li>
			)}
			{hasViewTransactionHistoryPermission(user.permissions) && (
				<li>
					<Link to="/paypoint/transaction-history">
						<div className="icon-w">
							<div className="os-icon os-icon-agenda-1" />
						</div>
						<span>Transaction History</span>
					</Link>
				</li>
			)}
			{hasViewTransactionHistoryPermission(user.permissions) && (
				<li>
					<Link to="/store/cafeteria-supplies">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Cafeteria Supplies</span>
					</Link>
				</li>
			)}
			{isSupervisor ||
				(hasViewCafeteriaInventoryPermission(user.permissions) && (
					<li>
						<Link to="/report/cafeteria">
							<div className="icon-w">
								<div className="os-icon os-icon-layers" />
							</div>
							<span>Reports</span>
						</Link>
					</li>
				))}
		</>
	);
};

export default CafeteriaMenu;
